var DEFAULT_PHONE_FORMAT = '... ... ... ... ...';

export { DEFAULT_PHONE_FORMAT };
